{
  "CommonAdminAllTelServer": "[Alle Telefonie-Server]",
  "CommonAdminAnyPartition": "[Beliebige Partition]",
  "CommonAdminAnyDevices": "[Beliebiges Gerät]",
  "CommonAdminAnyAgents": "[Beliebiger ACD-Agent]",
  "CommonAdminAnyAgentForDevice": "[Any At Set Device]",
  "CommonAdminAnyDeviceForAgent": "[Beliebig mit eingestelltem ACD-Agenten]",
  "CommonAdminUnknownOrDeleted": "[Unbekannt oder Gelöscht]",
  "NAME": "CommonAdmin"
}